import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useAuth from '../hooks/useAuth'

const hasUsableToken = () => {
    const token = window.localStorage.getItem('accessToken')
    if (!token || token === 'undefined' || token === 'null') return false
    try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        if (payload?.exp && payload.exp * 1000 <= Date.now()) return false
        return true
    } catch (e) {
        return false
    }
}

const AuthGuard = ({ children }) => {
    const { isAuthenticated } = useAuth()
    const location = useLocation()

    if (!isAuthenticated && !hasUsableToken()) {
        return (
            <Navigate
                to="/session/signin"
                replace
                state={{ from: location.pathname }}
            />
        )
    }

    return children
}

export default AuthGuard
